// Hideo - the PayPal donation button (DonateButton.vue: computer sidebar above Search, phone ☰ menu above Search).
// The button is shown only when DONATE_URL holds a PayPal address (paypal.me/… or paypal.com/…). The link comes from
// the build setting VITE_DONATE_URL (CONFIG, src/config.ts).

import { CONFIG } from '../config'

/** The PayPal link for donations ('' = no button), from VITE_DONATE_URL at build time */
export const DONATE_URL: string = CONFIG.donateUrl

/** The link the button opens: only an https PayPal address, otherwise '' (no button) */
export function donateHref(u: string = DONATE_URL): string {
  try {
    const url = new URL(u.trim())
    return url.protocol === 'https:' && /(^|\.)(paypal\.me|paypal\.com)$/i.test(url.hostname) ? url.href : ''
  } catch {
    return ''
  }
}
